import { DemoNav } from '@clearkit/icons';
import { CKSelectNext } from 'clearkit';

import { EnrichmentAttribute } from '~/generated/graphql';

function toSelectableItem(object: EnrichmentAttribute) {
  return {
    value: object.value,
    label: object.label,
  };
}

type SelectTargetAttributeProps = {
  items: EnrichmentAttribute[];
  value?: EnrichmentAttribute;
  label?: string;
  placeholder: string;
  isDisabled?: boolean;
  onChange: (newAttribute?: EnrichmentAttribute) => void;
  className?: string;
};
export function SelectTargetAttribute({
  items = [],
  value,
  onChange,
  label,
  ...props
}: SelectTargetAttributeProps) {
  return (
    <CKSelectNext
      {...props}
      items={items.map(toSelectableItem)}
      onChange={({ value }) => {
        const attribute = items.find(
          (attr: EnrichmentAttribute) => attr.value === value,
        );
        onChange(attribute);
      }}
      value={value && toSelectableItem(value)}
    >
      <CKSelectNext.Label className="font-medium">{label}</CKSelectNext.Label>
      <CKSelectNext.IconLeft>
        <DemoNav />
      </CKSelectNext.IconLeft>
    </CKSelectNext>
  );
}
